module.exports = __webpack_public_path__ + "static/img/b001e6b1866660a512ee7c6e0455f0bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/RoadTestView/images/disconnected.svg
// module id = 2791
// module chunks = 1